// extracted by mini-css-extract-plugin
module.exports = {"root":"PortalModal_root__MgV6O","overlay":"PortalModal_overlay__LPQ_h"};